common.View.create('shop::productVariant.createEdit.FilterValues', {

    onDOMLoad() {
        this.initFilterInputs();
    },

    initFilterInputs() {
        // Find search field
        $(document).on('change', '.crud\\:\\:form-dataset-table-Item .inputs .customInput:last input', (event) => {
            // No valid value given?
            if( !$(event.currentTarget).val() ) {
                return;
            }

            // Clone item?
            $(event.currentTarget).parents('.inputs').append(
                $(event.currentTarget).parents('.customInput').clone()
                    .find('input').val('').end()
            );
        });
    }

});
